import PageablePayload, { Pageable } from '@/model/PageablePayload';



export function mapToPageable(payload: any): Pageable {
  const { pageable, totalElements, totalPages } = payload;
  const newPageable: Pageable = {
    descending: pageable.descending,
    page: pageable.pageNumber + 1,
    rowsPerPage: pageable.pageSize,
    totalItems: totalElements,
    totalPages: totalPages,
  }
  return newPageable;
}
export function mapToPageablePayload<T>(json: any): PageablePayload<T> {
  const newPayload: PageablePayload<T> = {
    data: json.content as T[],
    pagination: mapToPageable(json)
  }
  return newPayload;
}